import { render } from "./ManuscriptOverview.vue?vue&type=template&id=4677246a&ts=true"
import script from "./ManuscriptOverview.vue?vue&type=script&lang=ts"
export * from "./ManuscriptOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__